import * as React from 'react';

export const IconMvk = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1.5H1.5V3V9H4.5V4.5H9V1.5H3ZM15 4.5H19.5V9H22.5V3V1.5H21H15V4.5ZM4.5 15V19.5H9V22.5H3H1.5V21V15H4.5ZM19.5 15V19.5H15V22.5H21H22.5V21V15H19.5ZM16.5 7.5H7.5V16.5H16.5V7.5Z"
      fill="white"
    />
  </svg>
);

IconMvk.displayName = 'IconMvk';
